const checkIfUnique = (records, rest) => {
    let n = rest.length
    let check = new Array(n).fill(new Array())
    for(let obj of records) {
        for(let i=0; i<n; i++) {
            let field = rest[i]
            if(obj[field] && check[i].includes(obj[field])) {
                let errors = obj.errors || {}
                errors[field] = `${field.replace('_', ' ').replace(field[0], field[0].toUpperCase())} should be unique`
                obj.errors = errors
            } else check[i].push(obj[field])
        }
    }
} 

export default checkIfUnique;